import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';

import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/400-italic.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';

const LayoutEmbed = ({ children }) => {
	return (
		<>
			<Helmet>
				<script src="https://unpkg.com/iframe-resizer@4.3.1/js/iframeResizer.contentWindow.min.js" />
			</Helmet>
			<div className="text-body-color">{children}</div>
		</>
	);
};

LayoutEmbed.propTypes = {
	children: PropTypes.node.isRequired
};

export default LayoutEmbed;
